import React from 'react'
import { StatusBar, StatusBarStyle } from 'expo-status-bar'
import { StyleSheet, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { useRouter } from 'expo-router'
import { useIsFocused } from '@react-navigation/native'

import { Header } from '@/components/Mini/Header'
import { DS } from '@/design-system'
import { RedeemCard } from '@/screens/diamonds/components/RedeemCard'

function RedeemScreen() {
  const router = useRouter()
  const isFocused = useIsFocused()

  return (
    <SafeAreaView style={styles.container}>
      {isFocused ? <StatusBar animated={true} style={'dark' as StatusBarStyle} hidden={false} /> : null}
      <Header
        theme={{ icon: 'Global/Black', accent: 'Global/Black' }}
        variant="Heading 3/Medium"
        title="Redeem"
        showKey={false}
        showDiamonds={false}
        handler={() => router.back()}
      />
      <View style={styles.content}>
        <View style={styles.webWrapper}>
          <RedeemCard />
        </View>
      </View>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: DS.palette['Brand/Cream']
  },
  content: {
    flex: 1,
    padding: DS.spacing[24],
    paddingBottom: DS.spacing[48]
  },
  webWrapper: {
    flex: 1,
    width: '100%',
    maxWidth: 600,
    alignSelf: 'center'
  }
})

export { RedeemScreen }
